import { render, staticRenderFns } from "./fccEtnia.vue?vue&type=template&id=4a4230ff"
import script from "./fccEtnia.vue?vue&type=script&lang=js"
export * from "./fccEtnia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports